// Copyright (c) 2017 Deere & Company

import AuditSummaryReport from '../../../reports/audit-summary/state-connector';

export default {
    component: AuditSummaryReport,
    name: 'AUDIT_SUMMARY',
    path: 'audit-summary'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/audit-summary.js